import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import classNames from 'classnames';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';
import useClickOutside from 'common/useClickOutside';

import Icons from 'assets/images/Icons';
import Setting from './Setting';
import Tag from './Tag';

import iconsIndex from 'assets/images/Icons/iconsIndex';

import './edit-workers.scss';


const EditWorkers = ({
  checkedIds,
  refetch,
  setting,
}: {
  checkedIds: Array<number>,
  refetch?(): void,
  setting: keyof typeof iconsIndex,
}) => {
  const { addToast } = useContext(UiContext);
  const [open, setOpen] = useState(false);
  const { isSuccess, isError, mutate } = useApi('patch', '/api/workers');
  const formMethods = useForm({ mode: 'onChange' });
  const { handleSubmit } = formMethods;
  const ref = useClickOutside(() => {
    setOpen(false);
  });
  const firstLoad = useRef(true);

  const Components = {
    Setting,
    Tag,
  };
  const Component = Components[setting as keyof typeof Components];

  const isAnyWorkerSelected = () => {
    if(0 === checkedIds.length) {
      addToast!('No worker selected', 'Error');
      return false;
    }
    return true;
  };

  const editTags = () => {
    if(isAnyWorkerSelected()){
      setOpen((old) => !old);
    }
  };

  const onSubmit = (data: Record<string, string | number>) => {
    let mutationParameters: Record<string, string | number>;

    if (Object.keys(data).includes('label')) {
      mutationParameters = { label: data.label };
    } else {
      const amount = Number(data.amount);
      const unit = Number(data.unit);

      // A cleared field parses to NaN; guard so we never PATCH alert_limit: NaN.
      if (!Number.isFinite(amount) || amount < 0) {
        addToast!('Enter a valid alert limit', 'Error');
        return;
      }
      mutationParameters = { alert_limit: amount * unit };
    }

    checkedIds.forEach((id) => {
      mutate({
        id,
        ...mutationParameters,
      });
    });
    if(refetch){
      refetch();
    }
    setOpen(false);
  };

  useEffect(() => {
    if(firstLoad.current) {
      firstLoad.current = false;
    } else {
      addToast!(isSuccess ? 'Worker(s) Updated' : 'Error updating worker(s)', isError ? 'Error' : undefined);
      firstLoad.current = true;
    }
  }, [isSuccess, isError]);

  return (
    <div ref={ref} className='icon-container'>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Icons name={setting} onClick={editTags} />
        <div className={classNames({
          inputs: true,
          open,
        })}>
          <FormProvider {...formMethods}>
            <Component open={open} />
          </FormProvider>
          <button className='primary small'>Set</button>
        </div>
      </form>
    </div>

  );
};

export default EditWorkers;